(function () {
  function initSlider(root) {
    if (!root || root.dataset.storeReady === 'true') return;
    root.dataset.storeReady = 'true';

    var viewport = root.querySelector('[data-store-viewport]');
    var track = root.querySelector('[data-store-track]');
    var prevBtn = root.querySelector('[data-store-prev]');
    var nextBtn = root.querySelector('[data-store-next]');
    var dotsWrap = root.querySelector('[data-store-dots]');
    if (!viewport || !track) return;

    track.querySelectorAll('[data-store-clone]').forEach(function (node) {
      node.remove();
    });

    var originalCards = Array.prototype.slice.call(track.children);
    if (!originalCards.length) return;

    (function interleaveSources() {
      var google = [];
      var trustpilot = [];
      var other = [];
      originalCards.forEach(function (card) {
        var source = card.getAttribute('data-review-source');
        if (source === 'google') google.push(card);
        else if (source === 'trustpilot') trustpilot.push(card);
        else other.push(card);
      });
      var mixed = [];
      var googleIndex = 0;
      var trustIndex = 0;
      while (googleIndex < google.length || trustIndex < trustpilot.length) {
        if (googleIndex < google.length) mixed.push(google[googleIndex++]);
        if (trustIndex < trustpilot.length) mixed.push(trustpilot[trustIndex++]);
      }
      mixed.concat(other).forEach(function (card) {
        track.appendChild(card);
      });
      originalCards = mixed.concat(other);
    })();

    var autoplay = root.getAttribute('data-store-autoplay') !== 'false';
    var delay = parseInt(root.getAttribute('data-store-delay') || '4000', 10);
    if (!delay || delay < 2000) delay = 4000;

    var index = 0;
    var perView = 1;
    var pages = 1;
    var timer = null;
    var animating = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function calcPerView() {
      var width = window.innerWidth;
      if (width >= 990) return Math.min(3, originalCards.length);
      if (width >= 750) return Math.min(2, originalCards.length);
      return 1;
    }

    function stepSize() {
      var cardWidth = originalCards[0].getBoundingClientRect().width;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return cardWidth + gap;
    }

    function buildClones() {
      track.querySelectorAll('[data-store-clone]').forEach(function (node) {
        node.remove();
      });
      originalCards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-store-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        track.appendChild(clone);
      });
    }

    function setOffset(position, animate) {
      if (animate === false) track.classList.add('is-instant');
      else track.classList.remove('is-instant');
      track.style.transform = 'translate3d(' + -(position * stepSize()) + 'px, 0, 0)';
      if (animate === false) {
        void track.offsetWidth;
        track.classList.remove('is-instant');
      }
    }

    function syncDots() {
      if (!dotsWrap || !pages) return;
      var active = ((index % pages) + pages) % pages;
      var fill = dotsWrap.querySelector('[data-store-pager-fill]');
      var count = dotsWrap.querySelector('[data-store-pager-count]');
      var trackBar = dotsWrap.querySelector('[data-store-pager]');
      if (fill && trackBar) {
        var max = Math.max(trackBar.clientWidth - fill.offsetWidth, 0);
        var progress = pages === 1 ? 0 : active / (pages - 1);
        fill.style.left = (progress * max) + 'px';
      }
      if (count) {
        var start = active + 1;
        var end = Math.min(active + perView, pages);
        var label = start === end ? String(start) : start + '–' + end;
        count.textContent = label + ' / ' + pages;
      }
    }

    function bodyOverflows(body) {
      var probe = body.cloneNode(true);
      probe.style.position = 'absolute';
      probe.style.visibility = 'hidden';
      probe.style.pointerEvents = 'none';
      probe.style.display = 'block';
      probe.style.height = 'auto';
      probe.style.maxHeight = 'none';
      probe.style.overflow = 'visible';
      probe.style.webkitLineClamp = 'unset';
      probe.style.width = body.clientWidth + 'px';
      body.parentElement.appendChild(probe);
      var overflows = probe.scrollHeight > body.clientHeight + 2;
      probe.remove();
      return overflows;
    }

    function syncReadMore() {
      track.querySelectorAll('.store-reviews__card-body').forEach(function (body) {
        var more = body.parentElement.querySelector('[data-store-more]');
        if (!more) return;
        more.hidden = !bodyOverflows(body);
      });
    }

    function updateLayout() {
      perView = calcPerView();
      pages = Math.max(1, originalCards.length);
      if (index >= originalCards.length) index = index % originalCards.length;
      if (index < 0) index = 0;
      setOffset(index, false);
      syncDots();
      syncReadMore();
    }

    function onTransitionEnd(event) {
      if (event.target !== track || event.propertyName !== 'transform') return;
      animating = false;
      if (index >= originalCards.length) {
        index = index - originalCards.length;
        setOffset(index, false);
      } else if (index < 0) {
        index = index + originalCards.length;
        setOffset(index, false);
      }
      syncDots();
    }

    function goTo(position, animate) {
      if (animating && animate !== false) return;
      index = position;
      if (animate !== false) animating = true;
      setOffset(index, animate !== false);
      syncDots();
    }

    function next() {
      goTo(index + 1, true);
    }

    function prev() {
      if (index <= 0) {
        index = originalCards.length;
        setOffset(index, false);
      }
      goTo(index - 1, true);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!autoplay || reduceMotion || originalCards.length <= perView) return;
      timer = setInterval(next, delay);
    }

    buildClones();
    track.addEventListener('transitionend', onTransitionEnd);
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    if (dotsWrap) {
      var pagerBar = dotsWrap.querySelector('[data-store-pager]');
      if (pagerBar) {
        pagerBar.addEventListener('click', function (event) {
          var rect = pagerBar.getBoundingClientRect();
          if (!rect.width) return;
          var ratio = (event.clientX - rect.left) / rect.width;
          ratio = Math.min(1, Math.max(0, ratio));
          var target = Math.round(ratio * Math.max(pages - 1, 0));
          var currentPage = ((index % pages) + pages) % pages;
          var delta = (target - currentPage + pages) % pages;
          goTo(index + delta, true);
          start();
        });
      }
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    var touchX = null;
    viewport.addEventListener('touchstart', function (event) {
      touchX = event.changedTouches[0].clientX;
      stop();
    }, { passive: true });
    viewport.addEventListener('touchend', function (event) {
      if (event.target.closest('[data-store-more]')) {
        touchX = null;
        start();
        return;
      }
      if (touchX == null) return;
      var deltaX = event.changedTouches[0].clientX - touchX;
      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0) next();
        else prev();
      }
      touchX = null;
      start();
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateLayout();
      start();
    });

    var modal = root.querySelector('[data-store-modal]');
    var lastFocus = null;

    if (modal) {
      modal.dataset.modalFor = root.id || '';
      document.querySelectorAll('[data-store-modal]').forEach(function (node) {
        if (node !== modal && node.dataset.modalFor === modal.dataset.modalFor) node.remove();
      });
      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-store-modal-close]')) closeModal();
      });
    }

    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('store-reviews-modal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
      start();
    }

    function openModal(card, trigger) {
      if (!modal || !card) return;
      var stars = card.querySelector('.store-reviews__card-stars');
      var title = card.querySelector('.store-reviews__card-title');
      var body = card.querySelector('.store-reviews__card-body');
      var name = card.querySelector('.store-reviews__name');
      var date = card.querySelector('.store-reviews__date');
      var verified = card.querySelector('.store-reviews__verified');
      var modalStars = modal.querySelector('[data-store-modal-stars]');
      var modalTitle = modal.querySelector('[data-store-modal-title]');
      var modalBody = modal.querySelector('[data-store-modal-body]');
      var modalName = modal.querySelector('[data-store-modal-name]');
      var modalDate = modal.querySelector('[data-store-modal-date]');
      var modalVerified = modal.querySelector('[data-store-modal-verified]');

      if (modalStars) modalStars.innerHTML = stars ? stars.innerHTML : '';
      if (modalTitle) modalTitle.textContent = title ? title.textContent : '';
      if (modalBody) modalBody.innerHTML = body ? body.innerHTML : '';
      if (modalName) modalName.textContent = name ? name.textContent : '';
      if (modalDate) modalDate.textContent = date ? date.textContent : '';
      if (modalVerified) modalVerified.hidden = !verified;

      lastFocus = trigger;
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      modal.hidden = false;
      document.body.classList.add('store-reviews-modal-open');
      stop();
      var closeBtn = modal.querySelector('[data-store-modal-close-btn]');
      if (closeBtn) closeBtn.focus();
    }

    root.addEventListener('click', function (event) {
      var more = event.target.closest('[data-store-more]');
      if (more) {
        event.preventDefault();
        openModal(more.closest('.store-reviews__card'), more);
        return;
      }
      if (event.target.closest('[data-store-modal-close]')) closeModal();
    });

    if (modal) {
      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
        }
      });
    }

    updateLayout();
    start();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncReadMore);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-store-reviews]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root =
      (event.target && event.target.querySelector && event.target.querySelector('[data-store-reviews]')) ||
      (event.target && event.target.hasAttribute && event.target.hasAttribute('data-store-reviews')
        ? event.target
        : null);
    if (root) {
      root.dataset.storeReady = 'false';
      initSlider(root);
    }
  });
})();
